// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/rentadoras-cars/list',
    name: 'rentadoras-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Rentadoras.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_rentadora_cars',
    },
  },
  {
    path: '/rentadoras-cars/update',
    name: 'rentadoras-cars-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/form/Rentadoras.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_rentadora_cars',
    },
  },
]

export default formTable
